<template>
    <span>
        <a href="##"
            class="btn-link btn-danger"
            :class="{ disabled: disabled }"
            @click.prevent="!disabled && (modals.notice = true)"
            :aria-disabled="disabled">
            <slot name="modal-link"></slot>
        </a>
        <!-- small modal -->
            <modal :show.sync="modals.notice" headerClasses="justify-content-center" type="notice" >
                <div slot="header">
                    <h3>Delete Report</h3>
                </div>
                <div class="container text-center">
                    <p>ARE YOU SURE YOU WANT TO DELETE THIS ITEM?</p>
                </div>
                <template slot="footer">
                    <div class="container alert_footer" >
                        <base-button type="danger" class="alert_footer_button btn_extra_small btn_info mr-4" @click.native="modals.notice = false">Close
                        </base-button>
                        <base-button type="primary" class="alert_footer_button btn_extra_small btn_info" @click.native="confirm">Confirm
                        </base-button>
                    </div>
                </template>
            </modal>
    
    </span>
</template>



<script>
    import { mapActions } from 'vuex';
    import {BaseButton, Modal} from '@/components'

    export default {
      name: "order-report-grid-delete",
      props:{
        id: {
            type: Number,
            default: 0
        },
        isIcon: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
      },
      data() {
            return {
                modals: {
                    notice: false,
                }
            };
        },
     components: {
      BaseButton,
      Modal
  }, 
  methods: {
    ...mapActions({ 
        getReports: "orderReport/getReports",
        removeReport: "orderReport/removeReport",
    }),
    confirm(e) {
        let ctx = this;
        ctx.removeReport(ctx.id).then(response => {
            ctx.getReports()
            ctx.modals.notice = false
        })
    },
  }
}
</script>
